import { useSelector } from "react-redux";

const EMPTY = [];

/**
 * Read-only consumer of the csrData slice for dropdowns. Polling and
 * fetching are owned by the orchestrator (startStudyDataLoad); the
 * dropdown just reads state. Pass kind: 'table' (default) or 'figure'.
 */
export const useCsrDropdownData = ({ kind = "table" } = {}) => {
  const studyId = useSelector(state => state.csrData.studyId);
  const status = useSelector(state => state.csrData.status);
  const pollingError = useSelector(state => state.csrData.pollingError);
  const bucket = useSelector(state =>
    kind === "figure" ? state.csrData.figures : state.csrData.tables
  );

  const items = bucket.data?.length ? bucket.data : EMPTY;
  const isReady = status === "ready" && bucket.fetched && !bucket.error;
  const isLoading = bucket.loading || (status === "polling" && !bucket.fetched);
  const error = bucket.error || (status === "error" ? pollingError : null);

  return { items, isLoading, isReady, error, studyId };
};
